/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import navigateToURL from 'lib/navigateToURL';
import Avatar, {getAvatarHeight} from 'ui-library/avatar/Avatar';
import {AvatarShape, AvatarSize} from 'ui-library/avatar/AvatarConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {Header1, Header2} from 'ui-library/Headers';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import SortableScrollableTable from 'ui-library/scrollable/SortableScrollableTable';

import {Team} from './OrganizationConstants';

const AVATAR_SIZE = AvatarSize.SMALL;

interface Props {
  organizationId: string;
  organizationName: string;
  organizationTeams?: Array<Team>;
}

class OrganizationTeamsTab extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  _getSortValue = (row: any, sortKey: any) => {
    const {team} = row.extra;
    return team[sortKey];
  };

  _getRowContentHeight = (): number => getAvatarHeight(AVATAR_SIZE);

  _handleOpenTeamPage = (teamId: any): void => {
    navigateToURL(`teams/${teamId}`);
  };

  _handleRowClick = (row: any): void => {
    const {team} = row.extra;
    this._handleOpenTeamPage(team.id);
  };

  override render(): JSX.Element {
    if (this.props.organizationTeams == null) {
      return <CenteredHorizontalThrobber />;
    }
    if (this.props.organizationTeams.length === 0) {
      return <div>This organization has no teams.</div>;
    }

    const columns = [
      {
        header: 'Name',
        accessorKey: 'name',
        flexGrow: 1,
        isCollapsible: false,
        isSortable: true,
        sortKey: 'name',
      },
      {
        header: 'Description',
        accessorKey: 'description',
        flexGrow: 1,
        isCollapsible: false,
        isSortable: false,
        sortKey: 'description',
      },
    ];

    const rows = this.props.organizationTeams.map((team) => ({
      id: team.id,
      data: {
        name: (
          <div>
            <Avatar
              className="u-mini-spacing-right"
              shape={AvatarShape.SQUARE}
              entity={team}
              size={AVATAR_SIZE}
            />
            {team.name}
          </div>
        ),
        description: team.description,
      },
      extra: {team},
    }));

    const currentUserTeams = this.props.organizationTeams.filter((team) => team.member);

    return (
      <div>
        <Header2>Your Teams</Header2>
        {currentUserTeams.length === 0 ? (
          'You have not joined any teams.'
        ) : (
          <Row className="u-small-spacing-top">
            {currentUserTeams.map((team, i) => (
              <Col sm={4} className="u-spacing-bottom" key={i}>
                <div
                  className="teams-previewCard"
                  onClick={() => {
                    this._handleOpenTeamPage(team.id);
                  }}
                >
                  <Avatar entity={team} size={AvatarSize.LARGE} shape={AvatarShape.SQUARE} />
                  <div className="teams-previewCard-info">
                    <Header1>{team.name}</Header1>
                    <div className="teams-previewCard-subtitle">
                      {`${team.memberCount || 0} ${pluralize(team.memberCount, 'Member')}`}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
        <Header2>Teams in {this.props.organizationName}</Header2>
        {/* TODO(Rachel): Move organizationTeams-table to className when ScrollableTable migrates. */}
        <div className="organizationTeams-table u-small-spacing-top">
          <SortableScrollableTable
            columns={columns}
            getSortValue={this._getSortValue}
            hasLineBelowHeader={false}
            initialRows={rows}
            initialSort={[{sortKey: 'name'}]}
            onRowClick={this._handleRowClick}
            getRowContentHeight={this._getRowContentHeight}
          />
        </div>
      </div>
    );
  }
}

export default OrganizationTeamsTab;
